import {base64DecodeUrlSafe} from '~/src/utilities/helpers/string';
import rollbar from '~/src/utilities/libs/rollbar';

const parseCookieJson = <T>(cookie: string): T | null => {
    try {
        return JSON.parse(base64DecodeUrlSafe(cookie));
    } catch (error) {
        rollbar.info('Failed to parse Cookie JSON', error);
    }

    return null;
};

/**
 * Return the value of a cookie
 * @param {string} cookie name
 * @param {string} [cookies] list of cookies (server side request or browser, defaults to document.cookie)
 * @returns {string}
 */
const getCookie = (name: string, cookies?: string): string | null => {
    if (!cookies) {
        try {
            cookies = document.cookie;
        } catch (error) {
            rollbar.info('Browser does not allow cookie access', error);
        }
    }
    const matches = cookies ? cookies.match('(^|[^;]+)\\s*' + name + '\\s*=\\s*([^;]+)') : '';
    return (matches && matches.pop()) || null;
};

/**
 * Return JSON stored in a url safe base64 encoded cookie
 * @param {string} cookie name
 * @param {string} [cookies] list of cookies (server side request or browser, defaults to document.cookie)
 * @returns {any}
 */
const getCookieJson = <T>(name: string, cookies?: string): T | null => {
    const cookie = getCookie(name, cookies);

    return (cookie && parseCookieJson<T>(cookie)) || null;
};

/**
 * Set a new cookie
 * @param {string} cookie name
 * @param {string} cookie value
 * @param {string} cookie [expdays=3650]
 */
const setCookie = (name: string, value: string, expdays = 3650) => {
    const date = new Date();
    date.setTime(date.getTime() + expdays * 24 * 60 * 60 * 1000);

    try {
        document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/;`;
    } catch (error) {
        rollbar.info('Browser does not allow cookie access', error);
    }
};

export {getCookie, getCookieJson, setCookie};
